export default "__VITE_ASSET__k6$EGMpl__"